import { Action, createReducer, on } from '@ngrx/store';
import { OnDemandActions } from './on-demand.actions';
import { initialState, OnDemandState, contentTypeAdapter, folderAdapter, videoAdapter } from './on-demand.state';

const _OnDemandReducer = createReducer(
  initialState,
  on(
    OnDemandActions.getContentTypesSuccess,
    (state, { data, totalPages, totalItems, currPage }): OnDemandState => ({
      ...state,
      contentTypesTotalPages: totalPages,
      contentTypesTotalItems: totalItems,
      contentTypesCurrPage: currPage,
      contentTypes: contentTypeAdapter.addMany(data, state.contentTypes),
      error: null,
    })
  ),
  on(
    OnDemandActions.initCollectionsSuccess,
    (state, { data, totalPages, totalItems, currPage, access }): OnDemandState => ({
      ...state,
      accessFolder: access || {},
      folderTotalPages: totalPages,
      folderTotalItems: totalItems,
      folderCurrPage: currPage,
      folders: folderAdapter.setAll(data, state.folders),
      error: null,
    })
  ),
  on(
    OnDemandActions.getCollectionsSuccess,
    (state, { data, totalPages, totalItems, currPage, access }): OnDemandState => ({
      ...state,
      accessFolder: { ...access, ...state.accessFolder },
      folderTotalPages: totalPages,
      folderTotalItems: totalItems,
      folderCurrPage: currPage,
      folders: folderAdapter.addMany(data, state.folders),
      error: null,
    })
  ),
  on(
    OnDemandActions.clearCollections,
    (state): OnDemandState => ({
      ...state,
      accessFolder: null,
      folderTotalPages: null,
      folderTotalItems: null,
      folderCurrPage: null,
      folders: folderAdapter.removeAll(state.folders),
      error: null,
    })
  ),
  on(
    OnDemandActions.getVideos,
    (state): OnDemandState => ({
      ...state,
      loadingVideos: true,
      error: null,
    })
  ),
  on(
    OnDemandActions.getVideosSuccess,
    (state, { data, totalPages, totalItems, currPage }): OnDemandState => ({
      ...state,
      videoTotalPages: totalPages,
      videoTotalItems: totalItems,
      videoCurrPage: currPage,
      videos: videoAdapter.addMany(data, state.videos),
      loadingVideos: false,
      error: null,
    })
  ),
  on(
    OnDemandActions.loadingVideos,
    (state, { isLoading }): OnDemandState => ({
      ...state,
      loadingVideos: isLoading,
      error: null,
    })
  ),
  on(
    OnDemandActions.clearVideos,
    (state): OnDemandState => ({
      ...state,
      videoTotalPages: null,
      videoTotalItems: null,
      videoCurrPage: null,
      videos: videoAdapter.removeAll(state.videos),
      error: null,
    })
  ),
  on(
    OnDemandActions.updateSliderStatus,
    (state): OnDemandState => ({
      ...state,
      isShowAll: !state.isShowAll,
      error: null,
    })
  ),
  on(
    OnDemandActions.updateSliderRange,
    (state, { range }): OnDemandState => ({
      ...state,
      sliderRange: range,
      error: null,
    })
  ),
  on(
    OnDemandActions.error,
    (state, { error }): OnDemandState => ({
      ...state,
      loadingVideos: false,
      error: error,
    })
  )
);

export function onDemandReducer(state: OnDemandState | undefined, action: Action) {
  return _OnDemandReducer(state, action);
}
